import WGS84Service from '../../../services/wgs84ProjectionService';
import DetailMixin from './detailMixin';
import overviewEditMixin from './overviewEditMixin';
import SocketMixin from './socketMixin';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import get from 'lodash/get';
import { getMapOverlayData } from '../../../utils/geoMapOverlayInfo';
import Dashboard from '../../../views/dashboards/dashboard';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'CoreDtwinDetail',
  components: {
    MarkdownItVueLight,
    Dashboard
  },
  mixins: [SocketMixin, overviewEditMixin, DetailMixin],
  props: {
    mapmode: {
      type: Boolean,
      required: false,
      default: false
    },
    hideItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['UiTheme']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    dtwinOverlayInfo() {
      return getMapOverlayData(get(this.dtwin, 'data.indoor'));
    },
    showMap() {
      if (this.mapmode) {
        return false;
      }
      if (get(this.dtwin, 'data.twinImagePreferOverMap') && get(this.dtwin, 'data.twinImageId')) {
        return false;
      }
      const coordinates = get(this.dtwin, 'coordinates.coordinates', [null, null]);
      const coordinate = {
        lat: coordinates[1],
        lon: coordinates[0]
      };
      return WGS84Service.isValidWgs84(coordinate);
    },
    headerBG() {
      if (get(this.dtwin, 'data.twinImageId')) {
        return `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}/upload/${this.dtwin.data.twinImageId}`;
      }
      return null;
    },
    showSkeletonLoader() {
      return get(this.dtwin, 'data', true) === true;
    },
    dtwinCoordinates() {
      return get(this.dtwin, 'coordinates.coordinates', [null, null]);
    },
    dtwinPolygon() {
      return get(this.dtwin, 'polygon.coordinates', []);
    },
    detailButtonIcon() {
      return this.twinCanBeEdited(this.dtwin) ? 'fa-edit' : 'fa-eye';
    },
    detailButtonTitle() {
      return this.twinCanBeEdited(this.dtwin) ? this.$i18n_t('Common.edit') : this.$i18n_t('DigitalTwin.DigitalTwin.viewDetails');
    },
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    parallaxHeight() {
      return this.mapmode ? 130 : 200;
    },
    descriptionHeight() {
      return `max-height: ${this.mapmode ? 100 : 250}px; overflow: auto;`;
    },
    showDetilsIdTrans() {
      return this.baseLink === 'digitaltwin-mgmt' ? this.$i18n_t('Common.twinId') : this.$i18n_t('Common.virtualId');
    },
    hasDependentDevices() {
      return this.twinDependencies && this.twinDependencies.virtualDevices && this.twinDependencies.virtualDevices.length > 0;
    }
  },
  watch: {},
  methods: {
    get
  }
};